import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AcdExtensionsService } from './api/acdExtensions.service';
import { BrickSettingsService } from './api/brickSettings.service';
import { BrickWallService } from './api/brickWall.service';
import { CallHistoryService } from './api/callHistory.service';
import { CallTagsService } from './api/callTags.service';
import { CallsService } from './api/calls.service';
import { ChatsService } from './api/chats.service';
import { ContactStatusService } from './api/contactStatus.service';
import { DirectoriesService } from './api/directories.service';
import { EmailsService } from './api/emails.service';
import { GrafanaService } from './api/grafana.service';
import { PushNotificationsService } from './api/pushNotifications.service';
import { RemoteControlService } from './api/remoteControl.service';
import { RocketChatWebhooksService } from './api/rocketChatWebhooks.service';
import { SessionsService } from './api/sessions.service';
import { SettingsService } from './api/settings.service';
import { SkillsService } from './api/skills.service';
import { SupervisingService } from './api/supervising.service';
import { TeamsBotsService } from './api/teamsBots.service';
import { UsersService } from './api/users.service';
import { ValuesService } from './api/values.service';
import { WebRtcService } from './api/webRtc.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AcdExtensionsService,
    BrickSettingsService,
    BrickWallService,
    CallHistoryService,
    CallTagsService,
    CallsService,
    ChatsService,
    ContactStatusService,
    DirectoriesService,
    EmailsService,
    GrafanaService,
    PushNotificationsService,
    RemoteControlService,
    RocketChatWebhooksService,
    SessionsService,
    SettingsService,
    SkillsService,
    SupervisingService,
    TeamsBotsService,
    UsersService,
    ValuesService,
    WebRtcService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
